














































import Card from "@/components/layout/card.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { DateTime, Interval } from "luxon";

// See https://github.com/kaorun343/vue-property-decorator for all options

interface PresetDate {
    label: string;
    value: string;
    start: DateTime;
    end: DateTime;
}

@Component({
    name: "TimePickerInline",
    components: { Card },
    filters: {
        time: (time: DateTime) => {
            return time.toLocaleString(DateTime.TIME_24_SIMPLE);
        },
    },
})
export default class TimePickerInline extends Vue {
    // A tick represents one hour
    ticks = 24;

    @Prop({ default: 0.25 })
    step: number; // 15 minutes

    @Prop({})
    interval: Interval;

    internalInterval = Interval.fromDateTimes(DateTime.utc().startOf("day"), DateTime.utc().endOf("day"));

    tickValues: [number, number] = [0, 24];

    get DateTime() {
        return DateTime;
    }

    get displayValue() {
        const interval = this.computeIntervalFromTicks();
        return (
            interval.start.toLocaleString(DateTime.TIME_24_SIMPLE) +
            " - " +
            interval.end.toLocaleString(DateTime.TIME_24_SIMPLE)
        );
    }

    created() {
        // @ts-ignore
        window.DateTime = DateTime;
        if (this.interval) this.internalInterval = this.interval;
        this.updateTicksFromTime();
    }

    updateIntervalFromTicks() {
        this.internalInterval = this.computeIntervalFromTicks();
    }

    computeDateTimeFromTickValue(value: number) {
        let dateTime = this.internalInterval.end.startOf("day").plus({ hours: value });
        if (value === 24) dateTime = dateTime.minus({ seconds: 1 });
        return dateTime;
    }

    computeIntervalFromTicks() {
        return Interval.fromDateTimes(
            this.computeDateTimeFromTickValue(this.tickValues[0]),
            this.computeDateTimeFromTickValue(this.tickValues[1]),
        );
    }

    updateTicksFromTime() {
        this.tickValues[0] = this.internalInterval.start.hour + this.internalInterval.start.minute / 60;
        this.tickValues[1] = this.internalInterval.end.hour + this.internalInterval.end.minute / 60;
    }

    emitUpdate() {
        this.$emit("update:interval", this.internalInterval);
        this.$emit("change");
    }
}
